import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });

export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Request failed";

export const api = {
  config: () => http.get("/config").then((r) => r.data),
  stats: () => http.get("/stats").then((r) => r.data),
  tokens: () => http.get("/tokens").then((r) => r.data),
  deals: (status = "open", address) => http.get("/deals", { params: { status, address } }).then((r) => r.data),
  deal: (id) => http.get(`/deals/${id}`).then((r) => r.data),
  settled: () => http.get("/settled").then((r) => r.data),
  messages: (id) => http.get(`/deals/${id}/messages`).then((r) => r.data),
  slippage: (body) => http.post("/slippage", body).then((r) => r.data),
  createDeal: (body) => http.post("/deals", body).then((r) => r.data),
  fund: (id, body) => http.post(`/deals/${id}/fund`, body).then((r) => r.data),
  reclaim: (id, body) => http.post(`/deals/${id}/reclaim`, body).then((r) => r.data),
  cancel: (id, body) => http.post(`/deals/${id}/cancel`, body).then((r) => r.data),
  sendMessage: (id, body) => http.post(`/deals/${id}/messages`, body).then((r) => r.data),
  acceptCounter: (id, body) => http.post(`/deals/${id}/accept-counter`, body).then((r) => r.data),
  alerts: (address) => http.get("/alerts", { params: { address } }).then((r) => r.data),
};
